import { Component } from "react";

export class LazyLoadErrorBoundary extends Component {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            height: "100vh",
            gap: 16,
          }}
        >
          <p>Ocurrió un error al cargar la página.</p>
          <button onClick={() => window.location.reload()}>Reintentar</button>
        </div>
      );
    }
    return this.props.children;
  }
}
